import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import moment from '../../lib/moment.js'
import get from 'lodash/get'
import arrow_down from '../../static/images/arrow-down.svg'
import arrow_up from '../../static/images/arrow-up.svg'
import { FONTS, COLORS } from '../../constants'

const header = [{ label: 'Start Date', value: 0 }, { label: 'Employee ID', value: 1 }, { label: 'Company Name', value: 2 },
  { label: 'LOB', value: 3 }, { label: 'Employee Name', value: 4 }, { label: 'Pay Grade Name', value: 5 },
  { label: 'Position', value: 6 }]

export default class CustomTableConfidential extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      id: '',
      sort_order: null,
      sort_column: 1,
    }
    this.handleClickRow = this.handleClickRow.bind(this)
    this.handleClickSort = this.handleClickSort.bind(this)
  }
  handleClickRow(e, edit_id, id) {
    this.props.handleClickEdit(id)
    this.setState({ id: edit_id })
  }
  handleClickSort(type) {
    if (type === this.state.sort_column) {
      this.setState({
        sort_order: !this.state.sort_order,
      })
    } else {
      this.setState({
        sort_order: !this.state.sort_order,
        sort_column: type,
      })
    }
    if (type === 0) this.props.sortBy('emp_code', !this.state.sort_order)
    else if (type === 1) this.props.sortBy('company', !this.state.sort_order)
    else if (type === 2) this.props.sortBy('lob', !this.state.sort_order)
    else if (type === 3) this.props.sortBy('emp_name', !this.state.sort_order)
    else if (type === 4) this.props.sortBy('level', !this.state.sort_order)
    else if (type === 5) this.props.sortBy('position', !this.state.sort_order)
    else if (type === 6) this.props.sortBy('salary', !this.state.sort_order)
    else if (type === 7) this.props.sortBy('other_income', !this.state.sort_order)
  }

  render() {
    const { sort_order, sort_column } = this.state
    return (
    /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <NewTable bordered hover>
          <Header>
            <tr>
              {
                header.map(h =>
                  (<HeadConfidential onClick={ () => this.handleClickSort(h.value) }>
                    { h.label }
                    { h.value === sort_column && (
                      sort_order && h.value === sort_column ?
                        <Icon src={ arrow_up } alt="logo" />
                        :
                        <Icon src={ arrow_down } alt="logo" />
                    )
                    }
                  </HeadConfidential>)
                )
              }
            </tr>
          </Header>
          <tbody style={ { width: '100%', display: 'block', maxHeight: 'calc(100vh - 200px)', overflowY: 'scroll' } }>
            {
              get(this.props, 'data.length') !== 0 &&
          get(this.props, 'data', []).map((d, key) =>

            (<tr style={ { hover: '#E5E5E5', background: (key === this.state.id && get(this.props, 'span')) ? '#E5E5E5' : '' } } onClick={ () => this.handleClickRow(this, key, d._id) }>
              <td>{ d.start_date ? moment(d.start_date).format('YYYY-MM-DD') : '' }</td>
              <td>{ d.emp_code }</td>
              <td>{ d.company }</td>
              <td>{ d.lob }</td>
              <td>{ d.emp_name }</td>
              <td>{ d.level }</td>
              <td>{ d.position }</td>
            </tr>)
          )}

          </tbody>
        </NewTable>
      </Wrapper>
    )
  }
}

CustomTableConfidential.propTypes = {
  handleClickEdit: PropTypes.func.isRequired,
}

const Wrapper = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`
const NewTable = styled(Table)`
  background: white;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  thead, tbody tr{
    display:table;
    width:100%;
    table-layout:fixed;
    font-family: ${FONTS.GOTHAM} !important;
  } 
`
const HeadConfidential = styled.th`
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Header = styled.thead`
  background: ${COLORS.TABLE_HEADER_COLOR};
`
const Icon = styled.img`
  height: 10px;
  margin-left: 5%;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/components/table-confidential/index.js